/* MolCellQuest — 画面遷移
   ルータは使わない。表示中のビューと、開いている問題の id だけを持つ。 */

export const nav = $state({
  view: "journey",
  problemId: null,
  trackId: "genome", // 学習タブでいま選んでいるトラック
  returnTo: "learn", // 問題画面から戻る先
});

export const NAV_ITEMS = [
  { id: "journey", em: "🗺️", label: "旅", short: "旅" },
  { id: "learn", em: "📚", label: "学習する", short: "学習" },
  { id: "dash", em: "📊", label: "統計", short: "統計" },
  { id: "leaderboard", em: "🏆", label: "ランキング", short: "ランク" },
];

/* 先頭へ戻す。同じ画面のまま中身だけ差し替わる場合（問題 → 次の問題）は、
   描画が終わったあとにブラウザのスクロールアンカリングが位置を戻してしまう
   ことがあるので、次のフレームでもう一度スクロールする。 */
function scrollTop() {
  window.scrollTo({ top: 0, behavior: "instant" });
  requestAnimationFrame(() => window.scrollTo({ top: 0, behavior: "instant" }));
}

export function go(view) {
  nav.view = view;
  scrollTop();
}

export function openProblem(id, from = "learn") {
  nav.problemId = id;
  nav.returnTo = from;
  nav.view = "prob";
  scrollTop();
}
